module.exports = __webpack_public_path__ + "img/instagram.e73252a0.png";